import { render } from "./BaseCircularScore.vue?vue&type=template&id=a7c365f8"
import script from "./BaseCircularScore.vue?vue&type=script&lang=js"
export * from "./BaseCircularScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__